"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};
var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};
import { Component, PropSync } from "vue-property-decorator";
import i18n from "@/lang";
import UiDrawer from "@/components/drawer/UiDrawer.vue";
import UiForm from "@/components/form/UiForm.vue";
import UiSubmit from "@/components/form/UiSubmit.vue";
import { Debounce } from "vue-debounce-decorator";
import { DrawerComponent } from "@/components/core";
let PassSearchForm = class extends DrawerComponent {
  constructor() {
    super(...arguments);
    this.methods = [
      {
        id: "interim",
        name: this.$t("vdadvancedsearch.interim_method")
      },
      {
        id: "forever",
        name: this.$t("vdadvancedsearch.forever_method")
      },
      {
        id: "date",
        name: this.$t("vdadvancedsearch.date_method")
      },
      {
        id: "all",
        name: this.$t("vdadvancedsearch.all_method")
      }
    ];
    this.pickerOptions = {
      shortcuts: [
        {
          // text: this.$t("loginlogs.nearweeks"),
          text: this.$t("loginlogs.today"),
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(new Date(start.toLocaleDateString()).getTime());
            picker.$emit("pick", [start, end]);
          }
        },
        {
          // text: this.$t("loginlogs.nearweeks"),
          text: this.$t("loginlogs.lastday"),
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(new Date(start.toLocaleDateString()).getTime() - 3600 * 1e3 * 24);
            start.setHours(0, 0, 0, 0);
            end.setTime(new Date(end.toLocaleDateString()).getTime());
            picker.$emit("pick", [start, end]);
          }
        },
        {
          // text: this.$t("loginlogs.nearweeks"),
          text: this.$t("loginlogs.thisweek"),
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - (start.getDay() - 1) * 3600 * 1e3 * 24);
            start.setHours(0, 0, 0, 0);
            picker.$emit("pick", [start, end]);
          }
        },
        {
          // text: this.$t("loginlogs.nearweeks"),
          text: this.$t("loginlogs.lastsevenday"),
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1e3 * 24 * 7);
            start.setHours(0, 0, 0, 0);
            picker.$emit("pick", [start, end]);
          }
        },
        {
          // text: this.$t("loginlogs.nearweeks"),
          text: this.$t("loginlogs.lastweek"),
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - (start.getDay() + 6) * 3600 * 1e3 * 24);
            start.setHours(0, 0, 0, 0);
            end.setTime(end.getTime() + (0 - end.getDay()) * 3600 * 1e3 * 24);
            picker.$emit("pick", [start, end]);
          }
        },
        {
          // text: this.$t("loginlogs.nearweeks"),
          text: this.$t("loginlogs.thismonth"),
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.setDate(1));
            start.setHours(0, 0, 0, 0);
            picker.$emit("pick", [start, end]);
          }
        },
        {
          // text: this.$t("loginlogs.nearweeks"),
          text: this.$t("loginlogs.lastthirtydays"),
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1e3 * 24 * 30);
            start.setHours(0, 0, 0, 0);
            picker.$emit("pick", [start, end]);
          }
        },
        {
          // text: this.$t("loginlogs.nearweeks"),
          text: this.$t("loginlogs.lastmonth"),
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(new Date(start.setMonth(start.getMonth() - 1)).setDate(1));
            start.setHours(0, 0, 0, 0);
            end.setTime(end.setDate(1));
            picker.$emit("pick", [start, end]);
          }
        }
      ],
      disabledDate(time) {
        return time.getTime() > new Date(new Date(new Date().toLocaleDateString()).getTime() + 24 * 60 * 60 * 1e3 - 1) || time.getTime() < new Date(new Date().setMonth(new Date().getMonth() - 6));
      }
    };
  }
  get $query() {
    return this._query;
  }
  created() {
    return __async(this, null, function* () {
    });
  }
  mounted() {
    return __async(this, null, function* () {
    });
  }
  static create(query) {
    const _vue = new this({
      i18n,
      el: document.createElement("div"),
      propsData: {
        query
      }
    });
    return _vue;
  }
  isEmptyString(str) {
    if (str === "" || str === null || str === void 0) {
      return true;
    } else {
      return false;
    }
  }
  search() {
    return __async(this, null, function* () {
      try {
        let searchParams = {
          params: {}
        };
        searchParams.params["status"] = this.$query.state;
        if (!this.isEmptyString(this.$query.applicant)) {
          searchParams.params["applicant"] = this.$query.applicant;
        }
        if (this.$query.expiryDate.length === 2) {
          searchParams.params["apply_start_time"] = Date.parse(this.$query.expiryDate[0]);
          searchParams.params["apply_end_time"] = Date.parse(this.$query.expiryDate[1]);
        } else {
          searchParams.params["apply_start_time"] = -1;
          searchParams.params["apply_end_time"] = -1;
        }
        if (!this.isEmptyString(this.$query.ip)) {
          searchParams.params["ip"] = this.$query.ip;
        }
        if (!this.isEmptyString(this.$query.period_type)) {
          searchParams.params["period_type"] = this.$query.period_type;
        }
        this.$emit("search", searchParams);
      } catch (error) {
      }
    });
  }
  clearDrawer() {
    return __async(this, null, function* () {
      this.$query.state = "pass";
      this.$query.expiryDate = [];
      this.$query.applicant = null;
      this.$query.ip = null;
      this.$query.period_type = null;
      yield this.search();
    });
  }
};
__decorateClass([
  PropSync("query")
], PassSearchForm.prototype, "_query", 2);
__decorateClass([
  Debounce(800)
], PassSearchForm.prototype, "search", 1);
PassSearchForm = __decorateClass([
  Component({
    components: {
      UiDrawer,
      UiForm,
      UiSubmit
    }
  })
], PassSearchForm);
export {
  PassSearchForm as default
};
